import { MergeRequest } from '../'
import { branch } from '../constants'

module.exports = () ->
  { className } = MergeRequest
  await new Weaver.Node(className).set('name', className).save({ branch, commitMessage: "Add Merge Request Migration." })
